import { useInView } from 'react-intersection-observer';
import { Spinner } from '@weareopenr/component-library';
import classnames from 'classnames/bind';
import SelectableList, { SelectableListOption } from '../SelectableList/SelectableList';
import styles from './SelectableListWithInfiniteScroll.module.scss';

const cx = classnames.bind(styles);

interface SelectableListWithInfiniteScrollProps {
  options: SelectableListOption[];
  selectedOptions: string[];
  onChange: (selectedOptions: string[]) => void;
  className?: string;
  hasNextPage?: boolean;
  onLoadMore?: () => void;
  isLoadingMore?: boolean;
}

const SelectableListWithInfiniteScroll = ({
  options,
  selectedOptions,
  onChange,
  className,
  hasNextPage,
  onLoadMore,
  isLoadingMore,
}: SelectableListWithInfiniteScrollProps) => {
  const { ref } = useInView({
    onChange: (inView) => {
      if (inView && hasNextPage && onLoadMore) {
        onLoadMore();
      }
    },
  });

  return (
    <div className={cx('scroll-container', className)}>
      <SelectableList options={options} selectedOptions={selectedOptions} onChange={onChange} />
      {isLoadingMore && (
        <div className={styles['loading-container']}>
          <Spinner size="medium" colour="rainbow" />
        </div>
      )}
      {hasNextPage && !isLoadingMore && <div ref={ref} className={styles['scroll-sentinel']} />}
    </div>
  );
};

export default SelectableListWithInfiniteScroll;
